import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const ModalContent = styled(Flex).attrs({
  column: true,
  justify: 'center',
  align: 'center',
  spacing: 20,
})`
  width: 80%;
  min-height: 400px;
  text-align: center;
  padding: 50px 0;
  margin: auto;
`;

export const StyledButton = styled(Button).attrs({
  appearance: 'success',
})`
  width: 162px;
  height: 41px;
  border-radius: 20px;

  font-size: 16px;
  line-height: 23px;
  text-align: center;
`;
